import { render, staticRenderFns } from "./PostCard.vue?vue&type=template&id=af4b9694&scoped=true&"
import script from "./PostCard.vue?vue&type=script&lang=js&"
export * from "./PostCard.vue?vue&type=script&lang=js&"
import style0 from "./PostCard.vue?vue&type=style&index=0&id=af4b9694&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4b9694",
  null
  
)

export default component.exports